import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, computed } from 'vue'
import { timeZoneEnum } from '../timeZoneEnum'
import { message as DcMessage } from '@dc-platform/dc-components'
import { personTimeZoneCreate, personTimeZoneEdit } from '@/api/common'
import type { PersonTimeZoneEditParams, PersonTimeZoneListItem } from '@/typings/api/overseasSales'


const __default__ = { name: 'ModalForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<PersonTimeZoneEditParams>({})
const formRules = reactive({
  select: [{ required: true, message: '请选择' }]
})
const emit = __emit

const rowsProps = ref<PersonTimeZoneListItem>()
// 弹窗标题
const modalTitle = computed(() => (rowsProps.value ? '编辑' : '新增'))
const init = (rows?: PersonTimeZoneListItem) => {
  rowsProps.value = rows
  if (rows) {
    dataForm.id = rows.id
    dataForm.employeeNo = rows.employeeNo
    dataForm.timeZoneId = rows.timeZoneId
  }
  visible.value = true
}
const filterOption = (input: string, option: { label: string; value: string }) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
const handleOk = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const params = rowsProps.value
      ? { id: rowsProps.value.id, timeZoneId: dataForm.timeZoneId }
      : { timeZoneId: dataForm.timeZoneId, employeeNo: dataForm.employeeNo }
    const func = rowsProps.value ? personTimeZoneEdit : personTimeZoneCreate
    func(params)
      .then(() => {
        DcMessage.success('操作成功！')
        emit('fetch')
        handleCancel()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
  setTimeout(() => {
    visible.value = false
  }, 20)
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    width: 600,
    title: modalTitle.value,
    confirmLoading: loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        "wrapper-col": { span: 24 },
        ref_key: "formRef",
        ref: formRef,
        model: dataForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "员工",
            name: "employeeNo",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UserSelect, {
                value: dataForm.employeeNo,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.employeeNo) = $event)),
                status: 1,
                allowClear: "",
                disabled: rowsProps.value
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "时区",
            name: "timeZoneId",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: dataForm.timeZoneId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.timeZoneId) = $event)),
                options: _unref(timeZoneEnum),
                "show-search": "",
                placeholder: "请选择",
                "filter-option": filterOption,
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})